import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/configuracionesReducer/actions'
import * as Notifications from '../../components/Common/notification'
import * as layoutActions from '../../reducers/layoutReducer/actions'

function* genSetCantidadDiasTurnero(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Guardando configuración' }))
        // llamo a la acción que trae los rubros
        let infoTurnero = yield calls.setCantidadDiasTurnero(e.payload)

        yield put(reducerActions.setCalendariosTurnero(infoTurnero))
    }
    catch (error) // error handle
    {
        if (error.Message) { 
            Notifications.showError("Error al guardar configuración");
            return;
        }
    }
    finally{ 
        yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genGetCalendariosTurnero(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Buscando turnos' }))
        // llamo a la acción que trae los rubros
        
        let calendariosTurnero = yield calls.getCalendariosTurnero(e.payload)

        yield put(reducerActions.setCalendariosTurnero(calendariosTurnero))
    }
    catch (error) // error handle
    {
        if (error.Message) { 
            Notifications.showError("Error al obtener información sobre turnero");
            return;
        }
    }
    finally{ 
        yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genEliminarCalendarioTurnero(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Eliminando horario' }))
        // llamo a la acción que trae los rubros
        
        let calendariosTurnero = yield calls.eliminarCalendarioTurnero(e.payload)

        yield put(reducerActions.setCalendariosTurnero(calendariosTurnero))

        if(e.payload.callback){
            e.payload.callback()
        }
        
    }
    catch (error) // error handle
    {
        if (error.error) { 
            Notifications.showError("Error al eliminar horario");
            return;
        }
    }
    finally{ 
        yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genSaveCalendarioHorario(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Guardando horario' }))
        // llamo a la acción que trae los rubros
        
        let calendariosTurnero = yield calls.saveCalendarioHorario(e.payload)

        yield put(reducerActions.setCalendariosTurnero(calendariosTurnero))

        if(e.payload.callback){
            e.payload.callback()
        }
        
    }
    catch (error) // error handle
    {
        if (error.error) { 
            Notifications.showError(error.error);
            return;
        }
    }
    finally{ 
        yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genEliminarCalendarioNoLaborable(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Eliminando día no laborable' }))
        // llamo a la acción que trae los rubros
        
        let calendariosTurnero = yield calls.eliminarCalendarioNoLaborable(e.payload)

        yield put(reducerActions.setCalendariosTurnero(calendariosTurnero))

        if(e.payload.callback){
            e.payload.callback()
        }
        
    }
    catch (error) // error handle
    {
        if (error.error) { 
            Notifications.showError("Error al eliminar día no laborable");
            return;
        }
    }
    finally{ 
        yield put(layoutActions.setLoading({ show: false}))
    }
}

function* genSaveCalendarioNoLaborable(e){
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Guardando día no laborable' }))
        // llamo a la acción que trae los rubros
        
        let calendariosTurnero = yield calls.saveCalendarioNoLaborable(e.payload)

        yield put(reducerActions.setCalendariosTurnero(calendariosTurnero))

        if(e.payload.callback){
            e.payload.callback()
        }
        
    }
    catch (error) // error handle
    {
        if (error.error) { 
            Notifications.showError(error.error);
            return;
        }
    }
    finally{ 
        yield put(layoutActions.setLoading({ show: false}))
    }
}

function* defaultSaga() {
    yield all([      
        takeLatest(reducerActions.SAGA_SET_DIAS_ADELANTE_TURNERO, genSetCantidadDiasTurnero),
        takeLatest(reducerActions.SAGA_GET_CALENDARIOS_TURNERO, genGetCalendariosTurnero),
        takeLatest(reducerActions.SAGA_ELIMINAR_CALENDARIO_HORARIO, genEliminarCalendarioTurnero),
        takeLatest(reducerActions.SAVE_CALENDARIO_HORARIO, genSaveCalendarioHorario),
        takeLatest(reducerActions.SAGA_ELIMINAR_CALENDARIO_NO_LABORABLE, genEliminarCalendarioNoLaborable),
        takeLatest(reducerActions.SAVE_CALENDARIO_NO_LABORABLE, genSaveCalendarioNoLaborable),
    ])
  }
  
  export const sagas = [
    defaultSaga
  ]